export default "__VITE_ASSET__CkBb3Bgx__"